'use strict';

/**
 * @description iiject sdk
 */
function injectPayUBillingSDK() {
    var sdkLinkElement = document.getElementById('payuSdkLink');
    if (sdkLinkElement) {
        var sdklink = sdkLinkElement.value;
        var head = document.getElementsByTagName('head').item(0);
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = sdklink;
        head.appendChild(script);
    }
}
/**
 * @description creates paymentoption
 * @param {string} callbackurl eventname
 * @param {string}  data to be sent to server eventname
 *  @param {string} dismissalUrl dismissal url
 * @param {string} key key
 * @returns {Object} config Object
 */
function createPayUOptions(callbackurl, data) {
    var options = {};
    if (data.payUOptionObject) {
        var obj = data.payUOptionObject;
        options = {
            key: obj.key,
            hash: obj.hash,
            txnid: obj.txnid,
            amount: obj.amount,
            firstname: obj.firstname,
            lastname: obj.lastname,
            email: obj.email,
            phone: obj.phone,
            productinfo: obj.productinfo,
            surl: obj.surl,
            furl: obj.furl
        };
    }

    return options;
}
module.exports = {
    injectPayUBillingSDK: injectPayUBillingSDK,
    createPayUOptions: createPayUOptions
};
